<template>
    <pc-modal ref="mfaRequiredDialog">
        <template v-slot:header>{{ mfaRequiredHeader }}</template>
        {{ mfaRequiredMessage }}
        <template v-slot:footer>
            <pc-button v-on:click="onMfaCancel">{{ cancelText }}</pc-button>
            <pc-button
                primary
                v-on:click="onGoToMyAccount">
                {{ goToMyAccountText }}
            </pc-button>
        </template>
    </pc-modal>
</template>
<script>
    //** if you use this component, you should add it to refs as 'mfaRequiredDialog' */
    import { KEYS, NAMESPACE } from "./i18n/mfaRequired.i18n";
    import { mapI18n } from "Util/i18n";

    export default {
        props: {
            manageAccountUrl: { type: String, required: false, default: null }
        },
        computed: {
            ...mapI18n({ ...KEYS }, NAMESPACE)
        },
        methods: {
            onMfaCancel() {
                this.$refs.mfaRequiredDialog.hide();
            },
            onGoToMyAccount() {
                if (!this.manageAccountUrl) {
                    throw "Missing URL for manage account page.";
                }
                this.$app.setHref(this.manageAccountUrl);
            },
            show() {
                this.$refs.mfaRequiredDialog.show();
            }
        }
    };
</script>
